<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_coche.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE COCHE</p>
    <p>
      Personaliza y configura tu seguro con las coberturas, garantías y
      servicios que realmente necesitas.
    </p>
    <p>A un precio especial por ser cliente.</p>

    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button
          class="pure-button botonLlamar"
          title="Pulsa el botón para llamar a tu oficina MMT"
        >
          Llama e infórmate
        </button>
      </a>
    </p>
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
.divHorizontal {
  display: inline-block;
  text-align: center;
}
.divCuponAmigo {
  align-items: center;
  justify-content: center;
}
</style>
